export const CLEAN_FORM = 'clientes/clientesvendedor/clean-form';
export const RECEIVE_RUTAS_LIST = 'clientes/clientesvendedor/receive-rutas-list';
export const SET_MASK = 'clientes/clientesvendedor/set-mask';
export const SET_ORDER = 'clientes/clientesvendedor/set-order';
export const SET_PAGE = 'clientes/clientesvendedor/set-page';
export const SET_PAGE_SIZE = 'clientes/clientesvendedor/set-page-size';
export const UPDATE_FIELD_FILTER = 'clientes/clientesvendedor/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'clientes/clientesvendedor/update-table-column';

